"use client";

import { useState, useEffect } from "react";
import { ChevronLeft, ChevronRight, Quote, Star } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Carousel, CarouselApi, CarouselContent, CarouselItem } from "@/components/ui/carousel";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function VoicesOfSatisfaction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const [api, setApi] = useState<CarouselApi>();
  const [current, setCurrent] = useState(0);
  const [count, setCount] = useState(0);
  const testimonials = [{
    quote: "Sparkle & Shine Maids transformed my home into a sanctuary. The attention to detail is incredible, and coming home to a spotless space is the ultimate luxury.",
    name: "Sarah J.",
    childAge: "Homeowner in Oakwood",
    avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700217/img/client_sarah.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700217/img/client_sarah.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700217/img/client_sarah.webp-wvc-sizes"
  }, {
    quote: "I’ve tried many cleaning services, but none match the consistency of this team. Every corner is dusted, and the house smells fresh and clean every time.",
    name: "Mark D.",
    childAge: "Busy Professional",
    avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700217/img/client_mark.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700217/img/client_mark.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700217/img/client_mark.png-wvc-sizes"
  }, {
    quote: "The move-out cleaning package was a lifesaver. We got our full deposit back because the place looked better than when we first moved in.",
    name: "Elena R.",
    childAge: "Recent Mover",
    avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700217/img/client_elena.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700217/img/client_elena.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700217/img/client_elena.webp-wvc-sizes"
  }, {
    quote: "Reliable, professional, and thorough. I love that they use eco-friendly products that are safe for my pets. Highly recommend their recurring service.",
    name: "David T.",
    childAge: "Pet Owner",
    avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700217/img/client_david.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700217/img/client_david.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700217/img/client_david.png-wvc-sizes"
  }, {
    quote: "The deep cleaning service was worth every penny. They reached spots I hadn't cleaned in years. My kitchen has never looked this bright.",
    name: "Priya K.",
    childAge: "Homeowner",
    avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700217/img/client_priya.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700217/img/client_priya.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700217/img/client_priya.png-wvc-sizes"
  }, {
    quote: "Sparkle & Shine Maids makes my life so much easier. I can finally spend my weekends relaxing instead of scrubbing floors. Truly a five-star service.",
    name: "Hannah B.",
    childAge: "Working Parent",
    avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700217/img/client_hannah.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700217/img/client_hannah.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700217/img/client_hannah.png-wvc-sizes"
  }];
  useEffect(() => {
    if (!api) return;
    setCount(api.scrollSnapList().length);
    setCurrent(api.selectedScrollSnap());
    api.on("select", () => {
      setCurrent(api.selectedScrollSnap());
    });
  }, [api]);
  return <section data-section-id="1078" id="voices-of-satisfaction" className="relative overflow-hidden bg-background py-28 md:py-36">
      {}
      <svg className="absolute top-0 left-0 w-full text-secondary" viewBox="0 0 1440 24" preserveAspectRatio="none" aria-hidden="true">
        <path d="M0,0 L0,12 C120,18 240,6 360,10 C480,14 600,4 720,8 C840,12 960,20 1080,14 C1200,8 1320,16 1440,10 L1440,0 Z" fill="currentColor" />
      </svg>

      {}
      <div aria-hidden="true" className="pointer-events-none absolute top-1/3 right-[8%] h-[520px] w-[520px] rounded-lg bg-sky-mist/50 blur-3xl" style={{
      borderRadius: "42% 58% 51% 49% / 47% 52% 48% 53%",
      mixBlendMode: "multiply"
    }} />
      <div aria-hidden="true" className="pointer-events-none absolute -top-12 left-[10%] h-[380px] w-[380px] bg-sky-mist/40 blur-3xl" style={{
      borderRadius: "55% 45% 60% 40% / 50% 55% 45% 50%",
      mixBlendMode: "multiply"
    }} />

      <div ref={ref} className={`relative mx-auto max-w-[1320px] px-[clamp(1.25rem,4vw,3rem)] transition-all duration-700 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`}>
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-10">
          {}
          <div className="relative lg:col-span-5">
            <div className="flex items-center gap-3">
              <span className="font-mono text-xs uppercase tracking-[0.18em] text-chart-2">
                 04 // Client Testimonials
              </span>
            </div>

            <h2 className="font-default mt-6 font-serif text-[clamp(2rem,4.2vw,3.75rem)] font-normal leading-[1.05] tracking-tight text-foreground">
              Voices of{" "}
              <span className="inline-block italic text-chart-2" style={{
              transform: "rotate(-1.5deg) translateY(2px)"
            }}>
                pristine homes
              </span>
            </h2>

            <p className="mt-6 max-w-md font-sans text-[clamp(1.0625rem,1.15vw,1.1875rem)] leading-[1.65] text-foreground/80">
              Hear from the families and professionals who trust Sparkle & Shine Maids to restore clarity and comfort to their living spaces every single day.
            </p>

            {}
            <div className="mt-10 flex items-center gap-5">
              <Button variant="outline" size="icon" onClick={() => api?.scrollPrev()} aria-label="Previous testimonial" className="size-12 rounded-lg border-[1.5px] bg-transparent shadow-sm transition-all hover:scale-[1.02] border-chart-2 text-chart-2">
                <ChevronLeft className="size-5" />
              </Button>

              <div className="flex items-center gap-2">
                <span className="font-mono text-sm font-medium tabular-nums text-chart-2">
                  {String(current + 1).padStart(2, "0")}
                </span>
                {}
                <div className="flex items-center gap-1.5 px-2">
                  {Array.from({
                  length: count
                }).map((_, i) => <span key={i} data-index={i} className="transition-all duration-300" aria-hidden="true">
                      <svg width="10" height="12" viewBox="0 0 10 12" fill="none" className={i === current ? "opacity-100" : "opacity-30"}>
                        <ellipse cx="5" cy="7.5" rx="3.5" ry="4" fill={i === current ? "var(--primary)" : "var(--foreground)"} />
                        <path d="M2.5 4 Q5 1.5 7.5 4" stroke="var(--foreground)" strokeWidth="1" fill="none" strokeLinecap="round" />
                        <path d="M5 1 L5 3" stroke="var(--foreground)" strokeWidth="1" strokeLinecap="round" />
                      </svg>
                    </span>)}
                </div>
                <span className="font-mono text-sm text-foreground/50 tabular-nums">
                  {String(count).padStart(2, "0")}
                </span>
              </div>

              <Button variant="outline" size="icon" onClick={() => api?.scrollNext()} aria-label="Next testimonial" className="size-12 rounded-lg border-[1.5px] bg-transparent shadow-sm transition-all hover:scale-[1.02] border-chart-2 text-chart-2">
                <ChevronRight className="size-5" />
              </Button>
            </div>

            {}
            <div className="pointer-events-none mt-12 hidden lg:block">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700217/img/sparkle_home_icon.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700217/img/sparkle_home_icon.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700217/img/sparkle_home_icon.png-wvc-sizes" alt="" loading="lazy" decoding="async" className="h-[180px] w-auto opacity-95" />
            </div>
          </div>

          {}
          <div className="relative lg:col-span-7">
            <Carousel setApi={setApi} opts={{
            loop: true,
            align: "start"
          }} className="w-full">
              <CarouselContent>
                {testimonials.map((t, i) => <CarouselItem key={i} data-index={i}>
                    <div className="relative">
                      {}
                      <svg aria-hidden="true" className="absolute -top-2 -right-2 z-10 h-12 w-12" viewBox="0 0 48 48" fill="none">
                        <path d="M48 0 L48 28 Q40 32 32 36 Q24 40 20 48 L48 48 Z" fill="var(--accent)" opacity="0.45" />
                        <path d="M48 0 L48 28 Q40 32 32 36 Q24 40 20 48" stroke="var(--chart-2)" strokeWidth="1" fill="none" opacity="0.5" />
                      </svg>

                      <div className="relative rounded-lg bg-background p-8 shadow-md md:p-10 border border-border">
                        {}
                        <div className="absolute -top-2 left-6 font-serif italic leading-none text-accent" style={{
                      fontSize: "4rem"
                    }} aria-hidden="true">
                          <Quote className="size-14 -scale-x-100" strokeWidth={1.5} fill="var(--accent)" />
                        </div>

                        {}
                        <div className="mt-6 flex items-center gap-1.5">
                          {Array.from({
                        length: 5
                      }).map((_, s) => <Star key={s} data-index={s} className="size-5 fill-primary text-primary" strokeWidth={1.5} />)}
                        </div>

                        {}
                        <p className="font-default mt-6 font-serif text-[clamp(1.25rem,1.6vw,1.5rem)] font-normal leading-[1.4] text-foreground">
                          {t.quote}
                        </p>

                        {}
                        <div className="mt-8 flex items-center gap-4 border-t border-border pt-6">
                          <div className="relative h-14 w-14 shrink-0 overflow-hidden rounded-lg shadow-sm" style={{
                        borderRadius: "52% 48% 58% 42% / 50% 55% 45% 50%"
                      }}>
                            <img src={t.avatar} data-wvc-srcset={t.srcset} data-wvc-sizes={t.sizes} alt={t.name} loading="lazy" decoding="async" className="h-full w-full object-cover" />
                          </div>
                          <div className="flex flex-col">
                            <span className="font-default font-sans text-base font-bold text-foreground">
                              {t.name}
                            </span>
                            <span className="font-sans text-sm text-foreground/70">
                              {t.childAge}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </CarouselItem>)}
              </CarouselContent>
            </Carousel>
          </div>
        </div>
      </div>

      {}
      <svg className="absolute bottom-0 left-0 w-full rotate-180 text-secondary" viewBox="0 0 1440 24" preserveAspectRatio="none" aria-hidden="true">
        <path d="M0,0 L0,12 C120,18 240,6 360,10 C480,14 600,4 720,8 C840,12 960,20 1080,14 C1200,8 1320,16 1440,10 L1440,0 Z" fill="currentColor" />
      </svg>
    </section>;
}